import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=b6361e44&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
import style0 from "./Settings.vue?vue&type=style&index=0&id=b6361e44&prod&scoped=true&lang=css"
import style1 from "./Settings.vue?vue&type=style&index=1&id=b6361e44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6361e44",
  null
  
)

export default component.exports